import { useEffect, useState } from 'react';
import { APP_VERSION } from '../version';

const DISMISSED_KEY = 'version_check_dismissed';
const VERSION_ENDPOINT = (() => {
	try {
		const url = new URL(process.env['API'] ?? '');
		const domain = url.origin;

		return `${domain}/version.json`;
	} catch {
		return '/version.json';
	}
})();

export const useVersionCheck = () => {
	const [serverVersion, setServerVersion] = useState<string | null>(null);
	const [dismissed, setDismissed] = useState(false);

	const checkVersion = async () => {
		try {
			const response = await fetch(`${VERSION_ENDPOINT}?t=${Date.now()}`, { cache: 'no-store' });

			if (!response.ok) return;

			const data = await response.json();

			if (data?.version) {
				setServerVersion(data.version);
			}
		} catch {
			// Network/JSON errors must never propagate to the user.
		}
	};

	useEffect(() => {
		checkVersion();

		const interval = setInterval(checkVersion, 60 * 1000);

		return () => clearInterval(interval);
	}, []);

	const isStale =
		!!serverVersion && serverVersion !== APP_VERSION && serverVersion !== sessionStorage.getItem(DISMISSED_KEY);

	const dismiss = () => {
		if (serverVersion) {
			sessionStorage.setItem(DISMISSED_KEY, serverVersion);
		}

		setDismissed(!dismissed);
	};

	return { isStale, dismiss };
};
